export default "__VITE_ASSET__895c3934__"